class DeleteWalletTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;

        this.state = this.injector.get('$state');
        this.http = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');

        this.key = 'delete-passbook';
        this.title = this.translate.instant('general.verbs.permanent_delete');
        this.level = 'archived-highlight';
        this.icon = 'trash-alt';
    }

    translatedValue(path, params) {
        return this.translate.instant(`wallets.templates.workflows.details.ask-to-delete-template.${path}`, params);
    };

    action(template, vm) {
        this.alert
            .animatedAlert(
                this.translatedValue('title'),
                this.translatedValue('content', {wallet_ticket_name: template.name}),
                'attention',
                {
                    confirmButtonText: this.translatedValue('confirm'),
                    cancelButtonText: this.translatedValue('cancel'),
                },
            )
            .then(() => {
                this.http
                    .delete(`wallets/templates/${template.id}`)
                    .then(() => this.state.go('app.wallets.templates.index'))
                    .catch(err => this.alert.handle(err));
            })
            .catch(err => this.alert.handle(err));
    }
}

angular
    .module('festzelt-os.modules.wallets.templates')
    .factory('deletePassbook', [
        '$injector',
        ($injector) => new DeleteWalletTemplateWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/workflows/details/delete.js